
import React, {Component} from "react";

import BadgesWindow from "./badges-window.js";


import "./badges-widget.css";

import badgesConfig from "./badges-config.js";

import Badge from "./badge.js";


class BadgesWidget extends Component {
    constructor(props) {
        super(props);

        this.state = {
            show_all_badges: false
        }
    }


    hideBadgesWindow() {
        this.setState({
            show_all_badges: false
        });
    }

    showBadgesWindow() {
        this.setState({
            show_all_badges: true
        });
    }


    getUnlockedBadges(level) {
        let unlockedBadges = [];

        let latestBadge = false;

        for (let index in badgesConfig) {
            let currentBadge = badgesConfig[index];

            if (level >= currentBadge.unlock_level) {
                unlockedBadges.push(currentBadge);

                if (!latestBadge || latestBadge.unlock_level < currentBadge.unlock_level) {
                    latestBadge = currentBadge;
                }
            }
        }


        return {
            latest_badge: latestBadge,
            unlocked_badges: unlockedBadges
        }
    }


    render () {
        let {current_step} = this.props;

        let level = Math.floor(current_step / 5) + 1;

        let {show_all_badges} = this.state;

        let unlockedBadges = this.getUnlockedBadges(level);

        return (
            <div className='badges_widget'>
                <div className='badges_widget_title'>Badges</div>
                {unlockedBadges.latest_badge && <div className='current_badge'><Badge badge_info={unlockedBadges.latest_badge} current={true}></Badge></div>}
                <div className='show_all_badges' onClick={this.showBadgesWindow.bind(this)}>Show all badges</div>
                {show_all_badges && <BadgesWindow current_level={level} hide_func={this.hideBadgesWindow.bind(this)} unlocked_badges={unlockedBadges.unlocked_badges} />}
            </div>
        );
    }
}

export default BadgesWidget;


// WEBPACK FOOTER //
// ./src/components/containers/home-player-dashboard/progress-map/widgets/badges-widget.js